import { useFetchAdminPanelUrl } from "./use-admin-panel-url";

/**
 * Opens a page of the admin panel in a new tab, e.g.
 * `open(adminPanelPath("returns", "shops", shopId))`. The address comes from
 * the backend (super admins only) when clicked, so it is never in a bundle.
 * The tab opens inside the click, then moves to the page once the address is
 * known: a popup blocker would refuse a tab opened after the request.
 * `onError` shows the failure (each app has its own toast).
 */
export function useOpenAdminPanel(onError: (message: string) => void) {
  const fetchUrl = useFetchAdminPanelUrl();
  return async (path: string) => {
    const tab = window.open("about:blank", "_blank");
    if (tab) tab.opener = null;
    try {
      const base = await fetchUrl();
      if (!base) throw new Error("Adresse de l'admin panel non configurée");
      if (tab) tab.location.href = `${base}${path}`;
      else window.location.assign(`${base}${path}`);
    } catch (error) {
      tab?.close();
      onError(
        error instanceof Error ? error.message : "Admin panel indisponible",
      );
    }
  };
}

/** Path segments are ids: encoded, never trusted. */
export const adminPanelPath = (...segments: string[]) =>
  `/${segments.map(encodeURIComponent).join("/")}`;
